import React, { FC } from "react";
import Svg, { Circle, G, Path } from "react-native-svg";
import { ICustomSvgProps } from "./AngryIcon";

const GreatIcon: FC<ICustomSvgProps> = (props) => {
  return (
    <Svg width={props.width} height={props.height} viewBox="0 0 313 313">
      <G transform="matrix(1,0,0,1,-52.3109,-44.8266)">
        <Circle
          cx="208.495"
          cy="201.01"
          r="156.184"
          fill={props.color || "rgb(146,190,91)"}
        />
      </G>
      <G transform="matrix(-1.4443,-1.76876e-16,1.76876e-16,-1.4443,469.206,541.657)">
        <Path
          d="M164.604,250.133C166.65,223.147 189.223,201.857 216.729,201.857C244.236,201.857 266.809,223.147 268.854,250.133L164.604,250.133"
          fill={props.strokeColor || "black"}
        />
      </G>
      <G transform="matrix(1,0,0,1,-1673.16,-36.7654)">
        <G transform="matrix(1,0,0,1,0,-4)">
          <Path
            d="M1747.58,158.04C1748.6,145.75 1758.91,136.08 1771.46,136.08C1784.01,136.08 1794.32,145.75 1795.34,158.04"
            fill="none"
            stroke={props.strokeColor || "black"}
            strokeWidth="8"
          />
        </G>
        <G transform="matrix(1,0,0,1,115.758,-4)">
          <Path
            d="M1747.58,158.04C1748.6,145.75 1758.91,136.08 1771.46,136.08C1784.01,136.08 1794.32,145.75 1795.34,158.04"
            fill="none"
            stroke={props.strokeColor || "black"}
            strokeWidth="8"
          />
        </G>
      </G>
    </Svg>
  );
};

export default GreatIcon;
